import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import dateFormat from "dateformat";

// Icons
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";

const OrderRow = ({ row }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const [statusBackgroundColor, setStatusBackgroundColor] = useState(null);
  const [statusColor, setStatusColor] = useState(null);

  useEffect(() => {
    if (row.delivery_status === "Pending") {
      setStatusColor("#E4A11B");
      setStatusBackgroundColor("rgba(240, 172, 78,  0.200)");
    } else if (row.delivery_status === "Preparing") {
      setStatusColor("#9FA6B2");
      setStatusBackgroundColor("rgba(159, 166, 178,  0.200)");
    } else if (row.delivery_status === "Out Of Delivery") {
      setStatusColor("#54B4D3");
      setStatusBackgroundColor("rgba(84, 180, 211,  0.200)");
    } else if (row.delivery_status === "Delivered") {
      setStatusColor("#14A44D");
      setStatusBackgroundColor("rgba(20, 164, 77,  0.200)");
    } else if (row.delivery_status === "Return") {
      setStatusColor("#DC4C64");
      setStatusBackgroundColor("rgba(220, 76, 100,  0.200)");
    }
  }, []);

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            <KeyboardArrowDownIcon
              style={{
                transition: "all 0.5s ease",
                transform: !open ? "rotate(0deg)" : "rotate(-180deg)",
              }}
            />
          </IconButton>
        </TableCell>
        <TableCell>
          <p style={{ fontWeight: 600, fontSize: "13px" }}>#{row._id}</p>
        </TableCell>
        <TableCell component="th" scope="row">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <p style={{ fontWeight: 600, fontSize: "15px" }}>{row.username}</p>
            <p
              style={{
                color: "hsl(240, 1%, 48%)",
                fontSize: "13px",
                fontWeight: 500,
              }}
            >
              {row.email}
            </p>
          </div>
        </TableCell>
        <TableCell>
          <div>
            <p style={{ fontWeight: 600, fontSize: "14px" }}>
              {dateFormat(new Date(row.orderDate), "mmm dd, yyyy")}
            </p>
            <p
              style={{
                color: "hsl(240, 1%, 48%)",
                fontSize: "13px",
                fontWeight: 500,
              }}
            >
              {dateFormat(new Date(row.orderDate), "hh:MM TT")}
            </p>
          </div>
        </TableCell>
        <TableCell>
          <p style={{ fontWeight: 600, fontSize: "14px" }}>{row.totalQTY}</p>
        </TableCell>
        <TableCell>
          <p style={{ fontWeight: 600, fontSize: "14px" }}>{row.price}</p>
        </TableCell>
        <TableCell>
          <p
            style={{
              background: statusBackgroundColor && statusBackgroundColor,
              color: statusColor && statusColor,
              fontWeight: 700,
              fontSize: "14px",
              maxWidth: "fit-content",
              padding: "3px 7px",
              borderRadius: "7px",
            }}
          >
            {row.delivery_status}
          </p>
        </TableCell>
        <TableCell>
          <IconButton onClick={() => navigate(`/orders/${row._id}/details`)}>
            <VisibilityIcon />
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Order Product List
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <p style={{ fontWeight: 600, fontSize: "15px" }}>
                        Particular Order Product ID
                      </p>
                    </TableCell>
                    <TableCell>
                      <p style={{ fontWeight: 600, fontSize: "15px" }}>
                        Product Name
                      </p>
                    </TableCell>
                    <TableCell>
                      <p style={{ fontWeight: 600, fontSize: "15px" }}>Size</p>
                    </TableCell>
                    <TableCell>
                      <p style={{ fontWeight: 600, fontSize: "15px" }}>Color</p>
                    </TableCell>
                    <TableCell align="right">
                      <p style={{ fontWeight: 600, fontSize: "15px" }}>QTY</p>
                    </TableCell>
                    <TableCell align="right">
                      <p style={{ fontWeight: 600, fontSize: "15px" }}>
                        Total price (₹)
                      </p>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.order_products.map((product) => (
                    <TableRow key={product._id}>
                      <TableCell component="th" scope="row">
                        <p style={{ fontWeight: 500, fontSize: "13px" }}>
                          #{product._id}
                        </p>
                      </TableCell>
                      <TableCell>
                        <p style={{ fontWeight: 500, fontSize: "13px" }}>
                          {product.productName}
                        </p>
                      </TableCell>
                      <TableCell>
                        <p style={{ fontWeight: 500, fontSize: "13px" }}>
                          {product.size}
                        </p>
                      </TableCell>
                      <TableCell>
                        <p style={{ fontWeight: 500, fontSize: "13px" }}>
                          {product.color}
                        </p>
                      </TableCell>
                      <TableCell align="right">
                        <p style={{ fontWeight: 500, fontSize: "13px" }}>
                          {product.qty}
                        </p>
                      </TableCell>
                      <TableCell align="right">
                        <p style={{ fontWeight: 500, fontSize: "13px" }}>
                          {product.regularPrice}
                        </p>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

OrderRow.propTypes = {
  row: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    orderDate: PropTypes.string.isRequired,
    totalQTY: PropTypes.number.isRequired,
    order_products: PropTypes.arrayOf(
      PropTypes.shape({
        _id: PropTypes.string.isRequired,
        productName: PropTypes.string.isRequired,
        qty: PropTypes.number.isRequired,
        regularPrice: PropTypes.number.isRequired,
      })
    ).isRequired,
    price: PropTypes.number.isRequired,
    delivery_status: PropTypes.string.isRequired,
  }).isRequired,
};

export default OrderRow;
